export class GameScoreItem {
  constructor(
    public category: string,
    public count: number,
    public player: string
  ) {}
}
